import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faMedal, faAward, faCertificate } from '@fortawesome/free-solid-svg-icons';

const FounderSection: React.FC = () => {
  return (
    <section className="section" id="founder">
      <Container>
        <Row className="align-items-center">
          <Col lg={5} className="mb-4 mb-lg-0">
            <div className="founder-image-container">
              <img
                src="https://static.wixstatic.com/media/5d7913_0e391af88ce6445a8fe7837fba8728be~mv2.png/v1/crop/x_147,y_171,w_647,h_647/fill/w_410,h_410,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202023-06-07%20at%2021_05_edite.png"
                alt="किशोर सलगर"
                className="img-fluid rounded"
                style={{ height: '400px', objectFit: 'cover', borderRadius: 'var(--border-radius-md)' }}
              />
            </div>
          </Col>
          <Col lg={7}>
            <div className="text-center">
  <h2 className="mb-4">आमचे संस्थापक</h2>
  <h3 className="text-primary mb-3">किशोर bapu सलगर</h3>
</div>

            <p className="lead mb-4">
              विमा उद्योगातील दूरदृष्टी असलेले नेतृत्व, अनेक प्रतिष्ठित पुरस्कारांचे मानकरी आणि समाजसेवेसाठी कार्यरत व्यक्तिमत्त्व.
            </p>
            <p className="mb-4">
              किशोर सलगर यांनी "जीवन आधार" ची स्थापना सर्वसमावेशक विमा सेवा देण्यासाठी व समाजाला योगदान देण्यासाठी केली.
              त्यांच्या आर्थिक नियोजन व विमा क्षेत्रातील अनुभवामुळे असंख्य कुटुंबांना सुरक्षित व स्थिर भविष्य मिळाले आहे.
            </p>

            <h4 className="mb-3">पुरस्कार आणि यशोगाथा</h4>
            <Row className="g-3 mb-4">
              <Col md={6}>
                <Card className="border-0 bg-light-gray">
                  <Card.Body className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faTrophy} className="text-primary me-3" size="2x" />
                    <div>
                      <h5 className="mb-1">६ वेळा MDRT</h5>
                      <p className="mb-0 small">मिलियन डॉलर राउंड टेबल</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="border-0 bg-light-gray">
                  <Card.Body className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faMedal} className="text-primary me-3" size="2x" />
                    <div>
                      <h5 className="mb-1">१ वेळा COT</h5>
                      <p className="mb-0 small">कोर्ट ऑफ द टेबल</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="border-0 bg-light-gray">
                  <Card.Body className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faAward} className="text-primary me-3" size="2x" />
                    <div>
                      <h5 className="mb-1">सर्वोत्तम कामगिरी</h5>
                      <p className="mb-0 small">LIC विमा उत्कृष्टता पुरस्कार</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="border-0 bg-light-gray">
                  <Card.Body className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faCertificate} className="text-primary me-3" size="2x" />
                    <div>
                      <h5 className="mb-1">उद्योग क्षेत्रातील नेता</h5>
                      <p className="mb-0 small">आर्थिक नियोजन संघटना</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FounderSection;
